import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Modal from "src/react/components/modal";
import { color } from "src/styles/variables";

const makeIframeContent = (data) => `
<html lang="en">
  <body>
    <form
      id="sca-form"
      action="${data.AuthenticationUrl}"
      method="POST"
    >
      <input
        hidden
        id="PaReq"
        name="PaReq"
        type="text"
        value="${data.PaReq}"
      />
      <input
        hidden
        id="MD"
        name="MD"
        type="text"
        value="${data.MD}"
      />
      <input
        hidden
        id="TermUrl"
        name="TermUrl"
        type="text"
        value="${data.origin}/sca3dsecure"
      />
    </form>
  </body>
</html>
`;

function ScaModal({ scaData, handleScaResult }) {
  const content = makeIframeContent({
    ...scaData,
    origin: window.location.origin,
  });

  useEffect(() => {
    window.addEventListener("message", handleScaResult);
    return () => {
      window.removeEventListener("message", handleScaResult);
    };
  }, [handleScaResult]);

  return (
    <Modal>
      <Wrapper data-selector="ScaModal">
        <Title>Your bank is validating your card</Title>
        <IFrame content={content} />
      </Wrapper>
    </Modal>
  );
}

ScaModal.propTypes = {
  handleScaResult: PropTypes.func.isRequired,
  scaData: PropTypes.object.isRequired,
};

export default ScaModal;

function IFrame({ content }) {
  const ref = useRef(null);

  useEffect(() => {
    try {
      if (content && ref.current && ref.current.contentDocument) {
        const doc = ref.current.contentDocument;
        doc.open();
        doc.write(content);
        doc.close();
        const form = doc.getElementById("sca-form");
        form.submit();
      }
    } catch (error) {
      console.error(error);
    }
  }, [content]);

  return (
    <iframe
      ref={ref}
      scrolling="no"
      seamless
      title="sca-form"
      frameBorder="0"
      height="625px"
      width="100%"
    />
  );
}

IFrame.propTypes = {
  content: PropTypes.string,
};

const MODAL_TOP_MARGIN_SMALL = 10;
const MODAL_TOP_MARGIN_LARGE = 40;
const WRAPPER_PADDING = 10;
const Wrapper = styled.div`
  overflow: auto;
  max-height: calc(
    100vh - ${MODAL_TOP_MARGIN_SMALL * 2 + WRAPPER_PADDING * 2}px
  );
  @media (min-width: 600px) {
    max-height: calc(100vh - ${MODAL_TOP_MARGIN_LARGE + WRAPPER_PADDING * 2}px);
  }
  padding: ${WRAPPER_PADDING}px;
`;

const Title = styled.h2`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
  color: ${color.grey};
`;
